export const POLISHING_DONE_REQUEST = "POLISHING_DONE_REQUEST";
export const POLISHING_DONE_SUCCESS = "POLISHING_DONE_SUCCESS";
export const POLISHING_DONE_FAILED = "POLISHING_DONE_FAILED";